import { motion } from "framer-motion";
import "./AwardsSection.scss";

const AwardsSection = () => {
  const awards = [
    "Blockchain Excellence Award",
    "Best EdTech Innovation 2024",
    "Educational Impact Award",
    "ISO 27001 Certified",
  ];

  const infiniteAwards = Array(10).fill(awards).flat();

  return (
    <section className="awards-section">
      {/* Top Header Strip with Awards */}
      <div className="awards-header-strip">
        <div className="awards-scroll-wrapper">
          <div className="awards-strip-content">
            {infiniteAwards.map((award, index) => (
              <span key={index} className="award-item">
                {award}
                <span className="separator">+++</span>
              </span>
            ))}
            {/* {infiniteAwards.map((award, index) => (
              <span key={`duplicate-${index}`} className="award-item">
                {award}
                <span className="separator">+++</span>
              </span>
            ))} */}
          </div>
        </div>
      </div>
      {/* Main Banner Section */}
      <p id="deploy-check-awards-bg"></p>
      <div className="awards-background">
        {/* Main Content Overlay */}
        <div className="awards-content">
          <motion.p
            className="company-name"
            initial={{ y: 0, scale: 1 }}
            animate={{
              y: [0, -15, 0],
              scale: [1, 1.05, 1],
            }}
            transition={{
              duration: 0.8,
              repeat: Infinity,
              repeatDelay: 2,
              ease: [0.68, -0.55, 0.265, 1.55],
            }}
          >
            Antier Solutions Pvt. Ltd.
          </motion.p>
          <h2 className="awards-title-main">
            Global Blockchain
            <br />
            <span>Innovator</span>
          </h2>
        </div>
      </div>
    </section>
  );
};

export default AwardsSection;
//committttttt